/**
 * @file Builds a goal's document id, `{subject}_{key}_{periodStart}`, where the key is the uid, the marked team
 * business group id or `org`. The key may hold underscores: the subject never does and the period is a fixed-width
 * `YYYY-MM-DD`, so the id decodes one way only, the subject as the text before the first `_`, the period as the last
 * 10 characters and the key as the remainder. `goalIdOf` in `firestore.rules` mirrors it and the read rules decode it
 * that way to decide visibility. Consumed by React goal reads and writes and by the Firestore rules tests.
 */
import type { AnalyticsGoal, AnalyticsGoalSubject } from './Analytics.Goal.types';

export const analyticsGoalId = (goal: AnalyticsGoalSubject & Pick<AnalyticsGoal, 'periodStart'>): string => {
  const key = goal.subject === 'user' ? goal.uid : goal.subject === 'team' ? goal.teamId : 'org';
  return [goal.subject, key, goal.periodStart].join('_');
};
